/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconAsteroid = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M16.5 11a5.25 5.25 0 1 1-.001 10.501A5.25 5.25 0 0 1 16.5 11zM5.363 6.174l2.121 2.121M10.136 8.825l1.061 1.061M13.96 8.407L7.5 2.022M2.25 7.272l6.407 6.438M11.253 16.417a2.253 2.253 0 1 1 .975 2.886" />
        <path d="M20.212 14.22a1.5 1.5 0 1 1-.001 3.001 1.5 1.5 0 0 1 .001-3.001z" />
      </g>
    </svg>
  ),
);
